export default __webpack_public_path__ + "static/media/logo.c04dfec3.png";